var HACKY_WORKSPACES = [
    'Citizens',
    'Citizens Theme Testing',
    'American Express',
    'Cash App',
    'One Finance',
    'TurboTax',
    'TurboTax (NativeLink Test)',
    'Redwood CU',
    'Redwood CU Theme Testing',
    'Flow',
    'Flow Theme Testing',
    'Plaid Theme Testing',
    'Discover HELOC',
    'Discover HELOC Theme Testing',
    'Citadel CU',
    'Citadel Theme Testing',
    'Y12',
    'DoorDash',
    'EliseAI',
    'Berkshire Bank',
    'Nassau Financial CU',
    'Key Bank',
    'Robinhood',
];
/**
 * This is a centralized function to check all in-mem workspace overrides.
 * This function's centralization is helpful to audit all our overrides that we
 * handle within Link (and not statsig or some external backend system).
 *
 * @param workspaceName - workspace from token
 * @param match - workspace name to match
 * @returns boolean
 */
export var checkHackyWorkspace = function (match, workspaceName) { return workspaceName === match; };
